import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const numberMoreThan0Message = () => i18n.t("validation.numberGreaterThanZero", {ns: "common"});

export const shiftOptionsValidation = yup.object().shape({
    options: yup.object().shape({
        shift: yup.object().shape({
            shiftControlIsActive: yup.boolean(),
            earliestShiftStart: yup.number().when("shiftControlIsActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            latestShiftEnd: yup.number().when("shiftControlIsActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            distanceAlertIsActive: yup.boolean(),
            distanceLimit: yup.number().when("distanceAlertIsActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            packageLimitAlertIsActive: yup.boolean(),
            maxShiftPackageLimit: yup.number().when("packageLimitAlertIsActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            })
        })
    })
});
